import React from "react";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { useTranslation } from "react-i18next";
import './PercentageComponent.css';

function PercentageComponent(props) {
    const { t } = useTranslation("common");
    return (
        <>
            <div className="percent_progress-chart-border col-md-4 col-lg-12 col-xl-5 col-xxl-5 col-sm-5">
                <div className="percent_progress-chart p-2 d-md-flex justify-content-center ">
                    <div className="percent_chart_card_header">
                        <CircularProgressbar
                            value={props.percentValue}
                            text={props.percentText !== null ? `${props.percentText}%` : t("keyPersonalInfo.hyphen")}
                            strokeWidth={20}
                        />
                    </div>
                </div>
                 
                <div className="percent_chart-title-footer">{t(props.title).concat(" " + t("welcome.vs") + " ") + t(props.ComparisonTitle)}
                </div>

                {
                    props.desc &&
                        <div className="percent_chart-desc-footer"> <span> {t(props.descTitle).concat(":")} </span> <span> {"- " + t(props.descValue)}</span> 
                        </div>
                    }
                
                
            </div>
        </>
    );
}

export default PercentageComponent;

